import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import { inject } from '@angular/core';
import { SettingsService } from './settings.service';
import {filter, first, map, shareReplay, tap} from 'rxjs/operators';

import {APIService, KPI} from '../api';


@Injectable()
export class ConfigService {
  private settings = inject(SettingsService);
  private api = inject(APIService);



  private _enableConsumingFeatures$: BehaviorSubject<boolean>;
  public get enableConsumingFeatures$(): Observable<boolean> {
    if (!this._enableConsumingFeatures$) {
      this._enableConsumingFeatures$ = new BehaviorSubject(false);
      this.api.get_decision_settings().subscribe((value) => {
        this._enableConsumingFeatures$.next(value.enable_consuming_features);
      });
    }
    return this._enableConsumingFeatures$;
  }

  private _showProjectsTab$: BehaviorSubject<boolean>;
  public get showProjectsTab$(): Observable<boolean> {
    if (!this._showProjectsTab$) {
      this._showProjectsTab$ = new BehaviorSubject(false);
      this.api.get_decision_settings().subscribe((value) => {
        this._showProjectsTab$.next(value.show_projects_tab);
      });
    }
    return this._showProjectsTab$;
  }

  /** Customer Config
   * @deprecated
   * @private
   */
  private _customerConfig$: BehaviorSubject<KPI.CustomerConfig> = new BehaviorSubject<KPI.CustomerConfig>(null);
  public customerConfig$ = this._customerConfig$.asObservable()
  public fetchCustomerConfig(): Subscription {
    return this.api.get_customer_config().pipe(
      map((customerConfigs) => {
        if (customerConfigs?.length) {
          const customerConfig = customerConfigs.find((config) => config.is_selected);
          if (customerConfig) {
            return {
              ...customerConfig,
              default_latitude: Number(customerConfig.default_latitude),
              default_longitude: Number(customerConfig.default_longitude),
            };
          }
        }
        return null
      }),
      tap((customerConfigs) => this._customerConfig$.next(customerConfigs)),
      first(),
    ).subscribe();
  }

  private _sitesMapLegendItems$: BehaviorSubject<KPI.SitesMapLegendItem[]>;
  public get sitesMapLegendItems$(): Observable<KPI.SitesMapLegendItem[]> {
    if (!this._sitesMapLegendItems$) {
      this._sitesMapLegendItems$ = new BehaviorSubject(null);
      this.api.get_sites_map_legend_items().subscribe((sitesMapLegendItems) => {
        this._sitesMapLegendItems$.next(sitesMapLegendItems);
      });
    }
    return this._sitesMapLegendItems$;
  }

  public get investmentDefaultColumns$(): Observable<string[]> {
    return this.customerConfig$.pipe(
      filter((customerConfig) => !!customerConfig),
      map((customerConfig) => !!customerConfig.investment_default_columns
        ? customerConfig.investment_default_columns.split(',')
        : [],
      ),
      shareReplay(1),
    );
  }

  public get assetDefaultColumns$(): Observable<string[]> {
    return this.customerConfig$.pipe(
      filter((customerConfig) => !!customerConfig),
      map((customerConfig) => (customerConfig as any).asset_default_columns
        ? (customerConfig as any).asset_default_columns.split(',')
        : [],
      ),
      shareReplay(1),
    );
  }

  public get workflowEnabled$(): Observable<boolean> {
    return this.api.get_decision_settings().pipe(
      map((data) => data.workflow_enabled),
      shareReplay(1),
    );
  }

  // alias for getSettingValue
  getSettingValue<T = any>(name: string, defaultValue?: T): T {
    return this.settings.getSettingValue(name, defaultValue);
  }

}
